import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, X } from "lucide-react";

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 180);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goContact = () => {
    if (location.pathname !== "/") {
      navigate("/#contact");
      setTimeout(() => {
        document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
      }, 120);
    } else {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  if (dismissed) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, x: 60 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 60 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed z-40 right-0 top-1/2 -translate-y-1/2 hidden md:block"
          data-testid="floating-cta-wrapper"
        >
          <div className="relative pr-3">
            <button
              onClick={() => setDismissed(true)}
              aria-label="Dismiss"
              data-testid="floating-cta-dismiss"
              className="absolute -left-1 -top-2 z-10 h-6 w-6 rounded-full bg-white border border-[#e7e5df] text-[#57534e] hover:text-[#1c1917] shadow-sm inline-flex items-center justify-center"
            >
              <X className="w-3 h-3" />
            </button>
            <button
              onClick={goContact}
              data-testid="floating-cta-btn"
              className="group relative flex items-center gap-3 pr-5 pl-4 h-14 rounded-l-2xl bg-[#16a34a] hover:bg-[#15803d] text-white font-bold text-sm shadow-[-8px_12px_30px_-10px_rgba(22,163,74,0.55)] transition-all duration-300 hover:pl-5"
            >
              <span className="h-9 w-9 rounded-xl bg-white/15 inline-flex items-center justify-center">
                <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition" />
              </span>
              <span className="leading-tight text-left">
                Get a
                <br />
                Free Estimate
              </span>
            </button>
          </div>
        </motion.div>
      )}

      {/* Mobile: compact bottom-right bubble */}
      {visible && (
        <motion.button
          key="mobile-cta"
          onClick={goContact}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.35 }}
          className="fixed z-40 md:hidden bottom-5 right-5 h-14 px-5 rounded-full bg-[#16a34a] text-white font-bold text-sm inline-flex items-center gap-2 shadow-[0_10px_30px_-8px_rgba(22,163,74,0.65)]"
          data-testid="floating-cta-mobile"
        >
          Free Estimate
          <ArrowRight className="w-4 h-4" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
